
/* injects from baggage-loader */

'use strict';

import AlertController from '../alert/alert.controller';

import { interview } from '_appRoot/index.const';

let { audio1, audio2, audio2B, audio3, audio4, audio5, audio6, audio7, audio8, audio8B } = interview.audios;

export default class DialogInterviewController extends AlertController{
  constructor($log, $rootScope, $timeout) {
        'ngInject';
        super($log);

        this.$rootScope = $rootScope;
        this.$timeout = $timeout;

        this.soundStatus = "on"

        this.state = {
          step: 1,
          steps: [
            { key: 'interviewer', value: 'O que motivou você a produzir vídeos e divulgá-los?', audio: audio1 },
            { key: 'interviewee', value: 'Eu sempre via outras pessoas fazendo vídeos. Aí eu disse: que legal! Criei um canal no YouTube e fui postando vídeos aleatórios.', audio: audio2},
            { key: 'interviewee', value: 'Um dia, fui ver e já tinha vários inscritos e eu gostei muito disso. No Music.ly, eu ainda faço vídeos até hoje, porque eu acho muito legal.', audio: audio2B},
            { key: 'interviewer', value: 'De onde surgem as ideias para os vídeos?', audio: audio3},
            { key: 'interviewee', value: 'Eu vejo vídeos antigos e tento fazer parecido. Às vezes, lembro de um fato que aconteceu comigo, aí eu vou lá e gravo, começo a falar do que aconteceu e posto.', audio: audio4},
            { key: 'interviewer', value: 'Quais recursos você utiliza para a produção dos vídeos?', audio: audio5},
            { key: 'interviewee', value: 'Uso a minha criatividade pra gravar, o que der pra gravar eu gravo. Eu uso o celular e, às vezes, uso meu tablet.', audio: audio6},
            { key: 'interviewer', value: 'O que você diria para uma criança que deseja criar vídeos autorais?', audio: audio7},
            { key: 'interviewee', value: 'Eu diria o que veio na minha cabeça quando eu quis começar: se eu quero, eu vou fazer, não vou poder ficar com essa ideia na cabeça e não querer fazer!', audio: audio8 },
            { key: 'interviewee', value: 'Então, eu diria para essa criança: você quer gravar vídeos? Você é boa? Siga o seu sonho e grave!', audio: audio8B }
          ]
        }
  }

  $onInit(){
    this.$timeout(() => {
      this.$rootScope.$emit('open:ballon', { key: this.state.step });
    });
  }
  
  $onDestroy(){
    this.$timeout(() => {
      this.$rootScope.$emit('interview:close', true);
    });
  }

  toggleSound(){
        if(this.soundStatus === "on"){
          this.soundStatus = "off";
          this.$rootScope.$emit('audio:off', true);
        }
        else if(this.soundStatus === "off"){
          this.soundStatus = "on";
          this.$rootScope.$emit('audio:on', true); 
        }
    }

  onSubmitBallon(){
    if( this.state.step >= ( this.state.steps.length )) {
      return this.ok();
    }
    this.state.step++;
    this.$rootScope.$emit('open:ballon', { key: this.state.step });
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/interview/interview.controller.js